// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as MetadataExtended } from '../../../../../ui-v3/src/assets/icons/extended/entities/metadata.svg?react';
import { createIcons } from '../../Icon';
const MetadataIcon = /* @__PURE__ */ createIcons('Metadata', {
    extended: MetadataExtended
});
MetadataIcon.supportedTypes = [
    'extended'
];
MetadataIcon.category = 'entities';
export default MetadataIcon;
